import { utils } from 'pixi.js';

export enum LevelActions {
    FINAL_REWARD = 'final reward',
    WATCH_PRESENT_AD = 'watch present ad',
    PRESENT_AD_COMPLETE = 'present ad complete',
    WIN_CLOSE = 'win close',
    WIN_COMPLETE = 'win complete',
}

export class LevelEmitter extends utils.EventEmitter {
    private static instanceCache: LevelEmitter;

    static get instance(): LevelEmitter {
        if (!this.instanceCache) {
            this.instanceCache = new LevelEmitter();
        }
        return this.instanceCache;
    }

    constructor() {
        super();
    }
}
